import { render, staticRenderFns } from "./InfosetsOverview.vue?vue&type=template&id=ed0c177c&"
import script from "./InfosetsOverview.vue?vue&type=script&lang=ts&"
export * from "./InfosetsOverview.vue?vue&type=script&lang=ts&"
import style0 from "./InfosetsOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports